import { render, staticRenderFns } from "./BtnVerLocalizacao.vue?vue&type=template&id=4301d778&"
import script from "./BtnVerLocalizacao.vue?vue&type=script&lang=js&"
export * from "./BtnVerLocalizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports